import { LineDowntimeModel } from "./line-downtime.model";

export class HourWiseDowntimeModel {
    hour: number;
    hourWiseDowntime: LineDowntimeModel[];

    constructor(hour: number,
        hourWiseDowntime: LineDowntimeModel[]) {
            this.hour = hour;
            this.hourWiseDowntime = hourWiseDowntime;
    }
}